import { Color } from '../colors/colors'
import parts, { ColorMaterialInformation } from '../colors/components'

const BASE_PRICE = 5490

/**
 * Mapping darüber, welcher Farbe für welche Komponente welchen Aufpreis kostet.
 * 
 */

interface Prices {
    [k: string]: number;
}

const additionalPrices: {[key: string]: Prices} = {
    [parts.GEHAUESE_PART]: {
        [Color.TITAN]: 0,
        [Color.FALLBACK]: 380
    },
    [parts.KRONE_PART]: {
        [Color.TITAN]: 0,
        [Color.FALLBACK]: 90,
    },
    [parts.SCHRAUBEN_PART]: {
        [Color.TITAN]: 0,
        [Color.FALLBACK]: 120
    },
    [parts.ZIFFERBLATT_PART]: {
        [Color.TITAN]: 0,
        [Color.FALLBACK]: 250
    },
    [parts.SEKZEIGER_PART]: {
        [Color.FALLBACK]: 0,
        [Color.TITAN]: 60
    },
    [parts.SEKRING_PART]: {
        [Color.TITAN]: 0,
        [Color.FALLBACK]: 120
    },
    [parts.ROTORWABEN_PART]: {
        [Color.TITAN]: 0,
        [Color.FALLBACK]: 90
    },
    [parts.WERKHALTERRING_PART]: {
        [Color.TITAN]: 0,
        [Color.FALLBACK]: 120
    },
}

class PricingService {
    static calculate(componentColors: {[k: string]: ColorMaterialInformation}): number {
        let price = BASE_PRICE
        for (const key in componentColors) {
            if (typeof additionalPrices[key] !== 'undefined') {
                price += this.getPriceForComponentWithColor(key, componentColors[key].color)
            }
        }
        return price
    }
    static getPriceForComponentWithColor(component: string, color: string) {
        if (typeof additionalPrices[component][color] !== 'undefined') {
            return additionalPrices[component][color]
        }
        return additionalPrices[component][Color.FALLBACK]
    }
}

export { PricingService, BASE_PRICE }